import React, { useEffect, useState } from 'react';
import { useLenis } from './SmoothScroll';
import './ScrollProgress.css';

const ScrollProgress = () => {
  const [progress, setProgress] = useState(0);
  const lenis = useLenis();

  useEffect(() => {
    const prefersReduced = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    if (prefersReduced) return undefined;

    const update = () => {
      const scrollHeight = document.documentElement.scrollHeight - window.innerHeight;
      const value = scrollHeight > 0 ? window.scrollY / scrollHeight : 0;
      setProgress(Math.min(1, Math.max(0, value)));
    };

    update();
    window.addEventListener('scroll', update, { passive: true });

    if (lenis) {
      lenis.on('scroll', update);
    }

    return () => {
      window.removeEventListener('scroll', update);
      if (lenis) {
        lenis.off('scroll', update);
      }
    };
  }, [lenis]);

  return (
    <div
      className="scroll-progress"
      aria-hidden="true"
      style={{ transform: `scaleX(${progress})` }}
    />
  );
};

export default ScrollProgress;
